import type { RegularAvailabilitySlotType } from '@discover-data/stores/restaurant/model/types';
import { type RegularAvailabilitySlotWithNonEmptyAvailabilityOptions } from '@discover-components/availability/options/dialog';

export default function hasNonEmptyAvailabilityOptions(
  slot: RegularAvailabilitySlotType
): slot is RegularAvailabilitySlotWithNonEmptyAvailabilityOptions {
  if (!slot.options) {
    return false;
  }

  if (Array.isArray(slot.options)) {
    return false;
  }

  const options = Object.values(slot.options);

  return options.every((option) => {
    if (!option) {
      return false;
    }

    if (Array.isArray(option)) {
      return option.length > 0;
    }

    return Object.values(option).length > 0;
  });
}
